
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { LayoutOps } from '../../layouts';
import { BackdropScreen, TarjetasOpciones } from '../../components';
import { useValidarRoles } from '../../../hooks';
import { descargarReciboOP, startDeleteOpAdmin } from '../../../services';
import { descargarPDF } from '../../../helpers/descargarArchivo';
import { useOPXID } from '../../../hooks/cache';

import Swal from 'sweetalert2';




export const DetallesOpCard = () => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { data:opdb } = useOPXID(id);  
    const { permitirXRol } = useValidarRoles();
    const [cargando, setCargando] = useState(false);
    

    const redirecPage = ( page ) => {
        navigate(`/super/${page}/${id}`);
    }


    const handleEliminarOP = async() => {
        const { value } = await Swal.fire({
            title: 'Eliminar O.P.',
            text: `¿Esta seguro de eliminar esta op y todas sus relaciones.?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si'
        });
        if( !value ) return;
        const resp = await startDeleteOpAdmin(id);
        if( resp ){ navigate(`/super/op-todas`); }
    }



    const handleDescargarInfo = async() => {
        const titulo = `Recibo-OP-${opdb.op}`
        setCargando(true);
        const datos = await descargarReciboOP(id);
        setCargando(false);
        descargarPDF(datos, titulo);
    }



    const data = [
        {key:1, titulo:'Gestión de Ítems', function:() => redirecPage('editar'), icono:'editar', url:'dd'},
        {key:2, titulo:'Ver Abonos', function:() => redirecPage('abonosxop'), icono:'abono', url:'dd'},
        // {key:3, titulo:'Items de Compra', function:() => redirecPage('items-produccion'), icono:'informacion', url:'dd'},
        {key:3, titulo:'Descargar Recibo', function:handleDescargarInfo, icono:'descargar', url:'dd'},
        ...(permitirXRol('SUPERADMIN', '') 
        ? [
            {key:4, titulo:'Insumos Asignados', function:() => redirecPage('inventario'), icono:'inventario', url:'ddd'},
            {key:5, titulo:'Eliminar O.P.', function: handleEliminarOP, icono:'eliminar', url:'dd'},
        ] 
        : []),        
    ];




    return (

        <LayoutOps titulo="Información de O.P.">
            <BackdropScreen cargando={cargando} titulo='Espere por favor estamos generando recibo...' />

            <Grid container spacing={3} sx={{display:'flex', alignItems:'stretch', mt:1}}>
                {data.map( item => (
                    <TarjetasOpciones
                        key={item.key}
                        onClickHandler={item.function} 
                        url={item.url} 
                        icono={item.icono} 
                        titulo={item.titulo} 
                    />
                ))}
            </Grid>
        </LayoutOps>


    )
}
